const LOGOUT_TRANSITION_KEY = 'disasterms_logout_transition';
const LOGOUT_TRANSITION_EVENT = 'disasterms:logout-transition';
const LOGOUT_TRANSITION_TTL_MS = 30_000;

let memoryTransition = null;

const notifyTransitionChanged = (transition) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new window.CustomEvent(LOGOUT_TRANSITION_EVENT, { detail: transition }));
};

const storage = () => {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  } catch (_) {
    return null;
  }
};

export const beginLogoutTransition = ({ isSaaS = false } = {}) => {
  const transition = {
    isSaaS: Boolean(isSaaS),
    startedAt: Date.now(),
  };
  memoryTransition = transition;
  try {
    storage()?.setItem(LOGOUT_TRANSITION_KEY, JSON.stringify(transition));
  } catch (_) {
    // The in-memory value still protects the current document when storage
    // is unavailable (for example, restrictive browser privacy settings).
  }
  notifyTransitionChanged(transition);
  return transition;
};

export const readLogoutTransition = () => {
  let transition = memoryTransition;
  try {
    const raw = storage()?.getItem(LOGOUT_TRANSITION_KEY);
    if (raw) transition = JSON.parse(raw);
  } catch (_) {
    // Fall back to the in-memory transition.
  }
  const startedAt = Number(transition?.startedAt || 0);
  if (!startedAt || Date.now() - startedAt > LOGOUT_TRANSITION_TTL_MS) {
    finishLogoutTransition();
    return null;
  }
  return transition;
};

export const finishLogoutTransition = () => {
  memoryTransition = null;
  try {
    storage()?.removeItem(LOGOUT_TRANSITION_KEY);
  } catch (_) {
    // Nothing else is required when storage is unavailable.
  }
  notifyTransitionChanged(null);
};

export { LOGOUT_TRANSITION_EVENT, LOGOUT_TRANSITION_KEY };
